import React from 'react';
import { Boxed } from '../../components/Boxed.components';
import { Text } from '../../components/Text.components';
import { Button } from '../../components/Button.components';

import FOOUR04_LOGO from '../../assets/img/404.png';

import { Theme } from '../../utils/theme';

export const Four04 = (props) => {
  const { redirect } = props;

  return (
    <>
      <Boxed display="flex" width="100%" minHeight="100vh">
        <Boxed margin="auto" minWidth="350px">
          <Boxed
            pad="20px"
            background="#FFFFFF"
            borderRadius={Theme.SecondaryRadius}
            boxShadow={Theme.PrimaryShadow}
          >
            <Boxed pad="10px 0" display="flex">
              <img src={FOOUR04_LOGO} height="200px" alt="404_logo" style={{ margin: '0 auto', borderRadius: '50%' }} />
            </Boxed>
            <Text align='center' fontSize="24px" fontWeight="bold" margin="5px 0">
              Oops.. Looks like you are lost.
            </Text>
            <Text align='center' margin="5px 0">Please click on the button bellow to go back.</Text>
            <Boxed pad="5px 0 0 0" display="flex">
              <Button margin="0 auto" onClick={() => redirect('/dashboard')}>
                Go back
              </Button>
            </Boxed>
          </Boxed>
        </Boxed>
      </Boxed>
    </>
  );
};
